import {
   CurrentDoctorSimpleQuery,
   DoctorSimple,
   DoctorSimpleFromCurrentHealthcareProviderQuery,
} from '@dreryk/egabinet-personnel-frontend-api';
import { PatientGroup, PatientGroupQuery } from '@dreryk/egabinet-patient-frontend-api';
import { CurrentHealthcareProviderPaymentsConfigurationEnabledQuery } from '@dreryk/egabinet-online-payments-integration-frontend-api';

import { isDemo } from '@dreryk/demo-variant-frontend';
import { useCqrsFind, useCqrsSearch } from '@dreryk/command-query-react-common';
import { commonTranslationKeys } from '@dreryk/react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

export type PrescriptionVisitsPanelLoaderRenderProps = {
   doctors: DoctorSimple[];
   currentDoctor: DoctorSimple | null;
   patientGroups: PatientGroup[];
   onlinePaymentsIntegrationExists: boolean;
};

type PrescriptionVisitsPanelLoaderProps = {
   readonly children: (renderProps: PrescriptionVisitsPanelLoaderRenderProps) => JSX.Element;
};

export const PrescriptionVisitsPanelLoader = (props: PrescriptionVisitsPanelLoaderProps): JSX.Element => {
   const { data: doctors, loading: doctorsLoading, error: doctorsError } = useCqrsSearch<DoctorSimple>(
      () => new DoctorSimpleFromCurrentHealthcareProviderQuery()
   );

   const { data: currentDoctor, loading: currentDoctorLoading, error: currentDoctorError } = useCqrsFind<DoctorSimple>(
      () => new CurrentDoctorSimpleQuery()
   );

   const { data: patientGroups, loading: patientGroupLoading, error: patientGroupError } = useCqrsSearch<PatientGroup>(
      () => new PatientGroupQuery()
   );

   const {
      data: onlinePaymentsIntegrationExists,
      loading: onlinePaymentsLoading,
      error: onlinePaymentsError,
   } = useCqrsFind(() => new CurrentHealthcareProviderPaymentsConfigurationEnabledQuery(), { enabled: !isDemo() });

   if (doctorsLoading || currentDoctorLoading || patientGroupLoading || onlinePaymentsLoading) {
      return <LoaderSpinner />;
   }

   if (doctorsError || currentDoctorError || patientGroupError || onlinePaymentsError) {
      return (
         <Message
            testId={'prescriptionVisitsFetchError'}
            type={MessageType.NEGATIVE}
            label={commonTranslationKeys.unexpectedErrorHasOccurred}
            displayIndicator
         />
      );
   }

   return props.children({
      doctors: doctors,
      currentDoctor: currentDoctor,
      patientGroups: patientGroups,
      onlinePaymentsIntegrationExists: Boolean(onlinePaymentsIntegrationExists),
   });
};
